export class Images {
  static base =
    "https://firebasestorage.googleapis.com/v0/b/portfolio-image-storage.appspot.com/o/";

  static hero =
    Images.base +
    "projects%2Fhero.webp?alt=media&token=53712075-5dff-4075-be1c-a6f5cd21ae60";

  static nda =
    Images.base +
    "projects%2Fnda.webp?alt=media&token=18241474-badb-4086-a069-4a477ba90fae";
  static asp =
    Images.base +
    "projects%2Fasp.webp?alt=media&token=57a38252-e55a-44e9-8a12-d2e52a5a0b92";
  static grove =
    Images.base +
    "projects%2Fgrove.webp?alt=media&token=8c9e190b-964e-4518-94e2-17fcb1cfe5fc";
  static cmLight =
    Images.base +
    "projects%2Fcm_light.webp?alt=media&token=c1d8d8ad-d6ce-467e-b44b-3438938cf21f";
  static dbLight =
    Images.base +
    "projects%2Fdb_light.webp?alt=media&token=69533f24-e782-4102-a1d3-8ed389a2e816";
  static bfLight =
    Images.base +
    "projects%2Fbd_light.webp?alt=media&token=9229ce64-78a2-4532-9aeb-70e360aee41b";
  static armLight =
    Images.base +
    "projects%2Farm_light.webp?alt=media&token=d2e7e7d0-15ec-4de1-93cb-f3bbbfd3f5b1";
  static mnmLight =
    Images.base +
    "projects%2Fmnm_light.webp?alt=media&token=f511340c-74dc-424f-8efe-52445bd8e8cd";
  static mikoLight =
    Images.base +
    "projects%2Fmiko_light.webp?alt=media&token=26f08108-569e-44f7-8cc5-b3bf9bfc9c1d";
  static hpLight =
    Images.base +
    "projects%2Fplanter_light.webp?alt=media&token=6aec8174-5be5-46cb-83a5-18f889630696";
  static payclixLight =
    Images.base +
    "projects%2Fpayclix_light.webp?alt=media&token=9cafa15e-a32e-4f7e-8d7a-ba6d055bc764";
  static souqcardsLight =
    Images.base +
    "projects%2Fsouqcards_light.webp?alt=media&token=9c3c093f-1440-47ee-b23e-294c9534a508";

  static cmDark =
    Images.base +
    "projects%2Fcm_dark.webp?alt=media&token=8d6e142d-8385-4259-b454-80fb304ff747";
  static dbDark =
    Images.base +
    "projects%2Fdb_dark.webp?alt=media&token=5484588b-36b8-4f4e-b092-129ff1ddabba";
  static bfDark =
    Images.base +
    "projects%2Fbd_dark.webp?alt=media&token=80699700-64b4-4d38-b9b3-1ad860fdd96c";
  static mnmDark =
    Images.base +
    "projects%2Fmnm_dark.webp?alt=media&token=aa9fc02e-d97e-4191-b7f8-36a221edbe23";
  static armDark =
    Images.base +
    "projects%2Farm_dark.webp?alt=media&token=9cd86339-301f-42c0-9b63-061e8531ea79";
  static mikoDark =
    Images.base +
    "projects%2Fmiko_dark.webp?alt=media&token=98f6e4a4-f848-49ad-a21f-8e7ad731d3db";
  static hpDark =
    Images.base +
    "projects%2Fplanter_dark.webp?alt=media&token=fd1536a7-9eac-4d77-9c92-dff95569b992";
  static payclixDark =
    Images.base +
    "projects%2Fpayclix_dark.webp?alt=media&token=8732062f-6a3a-4fee-9e76-6329ddff77b7";
  static souqcardsDark =
    Images.base +
    "projects%2Fsouqcards_dark.webp?alt=media&token=ee331ee2-20db-446a-98d2-00bbc2e14a15";

  static profile =
    Images.base +
    "profile%2Fprofile-pic%20(2).png?alt=media&token=43138bf5-2cb1-4915-be5e-ddbc15fad2f9";

  static icASP =
    Images.base +
    "icons%2Fasp.webp?alt=media&token=637a8e26-27c5-4b81-9273-bfece8dfcfa4";
  static icNDA =
    Images.base +
    "icons%2Fnda.webp?alt=media&token=bd5439c6-852a-4677-9fb3-9213ee64bd83";
  static icHP =
    Images.base +
    "icons%2Fhp.webp?alt=media&token=15de4513-0282-49a2-ad15-bf3326033ab9";
  static icCM =
    Images.base +
    "icons%2Fcm.webp?alt=media&token=5586e464-0c9f-4aab-82b6-248d9856568c";
  static icBF =
    Images.base +
    "icons%2Fbf.webp?alt=media&token=722ce1c1-6782-4815-883e-562c651b81e3";
  static icMNM =
    Images.base +
    "icons%2Fmnm.webp?alt=media&token=859044d9-5728-411a-ba03-ca7575562c0e";
  static icArm =
    Images.base +
    "icons%2Farm.webp?alt=media&token=006cd37b-be57-40cf-92f1-02ac7fac016c";
  static icMiko =
    Images.base +
    "icons%2Fmiko.webp?alt=media&token=d6c29af5-4e54-4d20-be85-abfb16884903";
  static icBD =
    Images.base +
    "icons%2Fdietbite.webp?alt=media&token=d7fdab8e-c990-41b1-b450-3a95644114da";
  static icPayclix =
    Images.base +
    "icons%2Fpayclix.webp?alt=media&token=05e9b705-a558-4b07-878f-ec2cf2aaebe9";
  static icSouqcards =
    Images.base +
    "icons%2Fsouqcards.webp?alt=media&token=0100d5de-b59a-48f7-a492-50492ef52e77";

  static icCover =
    Images.base +
    "cover%2Fcover_2.webp?alt=media&token=182965ff-38b9-46c5-ba7c-30f58bbc64dd";
}
